module.exports = {"FelineQueen":"fq","TreasureRaider":"tr"}


//////////////////
// WEBPACK FOOTER
// ./config/themes.yaml
// module id = 8
// module chunks = b-loader